import { Icon } from '../../../structure/icon/Icon'

export const DateIcon = () => (
  <Icon
    name="Calendar"
    className="m-0.5" // aligns with the padded icon of InsideInputIconButton
  />
)
